import { render, staticRenderFns } from "./KnowledgeBasePost.vue?vue&type=template&id=6b7dee2a&scoped=true"
import script from "./KnowledgeBasePost.vue?vue&type=script&lang=js"
export * from "./KnowledgeBasePost.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeBasePost.vue?vue&type=style&index=0&id=6b7dee2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7dee2a",
  null
  
)

export default component.exports